export enum EProductAplication {
  TODOS = 0,
  AGGILIZADOR_DESKTOP = 1,
  AGGILIZADOR_WEB = 2,
  GESTOR = 3,
  PLATAFORMA = 4,
}
